'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// @inheritedComponent ButtonBase
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import resolveProps from '@mui/utils/resolveProps';
import composeClasses from '@mui/utils/composeClasses';
import { alpha } from '@mui/system/colorManipulator';
import ButtonBase from "../ButtonBase/index.js";
import capitalize from "../utils/capitalize.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import toggleButtonClasses, { getToggleButtonUtilityClass } from "./toggleButtonClasses.js";
import ToggleButtonGroupContext from "../ToggleButtonGroup/ToggleButtonGroupContext.js";
import ToggleButtonGroupButtonContext from "../ToggleButtonGroup/ToggleButtonGroupButtonContext.js";
import isValueSelected from "../ToggleButtonGroup/isValueSelected.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, fullWidth = ownerState.fullWidth, selected = ownerState.selected, disabled = ownerState.disabled, size = ownerState.size, color = ownerState.color;
    var slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            "size".concat(capitalize(size)),
            color
        ]
    };
    return composeClasses(slots, getToggleButtonUtilityClass, classes);
};
var ToggleButtonRoot = styled(ButtonBase, {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["size".concat(capitalize(ownerState.size))]
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj;
    return _object_spread_props(_object_spread({}, theme.typography.button), (_obj = {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: "1px solid ".concat((theme.vars || theme).palette.divider),
        color: (theme.vars || theme).palette.action.active
    }, _define_property(_obj, "&.".concat(toggleButtonClasses.disabled), {
        color: (theme.vars || theme).palette.action.disabled,
        border: "1px solid ".concat((theme.vars || theme).palette.action.disabledBackground)
    }), _define_property(_obj, '&:hover', {
        textDecoration: 'none',
        // Reset on mouse devices
        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
            backgroundColor: 'transparent'
        }
    }), _define_property(_obj, "variants", [
        {
            props: {
                color: 'standard'
            },
            style: _define_property({}, "&.".concat(toggleButtonClasses.selected), {
                color: (theme.vars || theme).palette.text.primary,
                backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha(theme.palette.text.primary, theme.palette.action.selectedOpacity),
                '&:hover': {
                    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.hoverOpacity, "))") : alpha(theme.palette.text.primary, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha(theme.palette.text.primary, theme.palette.action.selectedOpacity)
                    }
                }
            })
        }
    ].concat(_to_consumable_array(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(function(param) {
        var _param = _sliced_to_array(param, 1), color = _param[0];
        return {
            props: {
                color: color
            },
            style: _define_property({}, "&.".concat(toggleButtonClasses.selected), {
                color: (theme.vars || theme).palette[color].main,
                backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.selectedOpacity),
                '&:hover': {
                    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.hoverOpacity, "))") : alpha(theme.palette[color].main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.selectedOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.selectedOpacity)
                    }
                }
            })
        };
    })), [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                padding: 7,
                fontSize: theme.typography.pxToRem(13)
            }
        },
        {
            props: {
                size: 'large'
            },
            style: {
                padding: 15,
                fontSize: theme.typography.pxToRem(15)
            }
        }
    ])), _obj));
}));
var ToggleButton = /*#__PURE__*/ React.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    var _React_useContext = React.useContext(ToggleButtonGroupContext), contextValue = _React_useContext.value, contextProps = _object_without_properties(_React_useContext, [
        "value"
    ]);
    var toggleButtonGroupButtonContextPositionClassName = React.useContext(ToggleButtonGroupButtonContext);
    var resolvedProps = resolveProps(_object_spread_props(_object_spread({}, contextProps), {
        selected: isValueSelected(inProps.value, contextValue)
    }), inProps);
    var props = useDefaultProps({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'standard' : _props_color, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, onChange = props.onChange, onClick = props.onClick, selected = props.selected, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, value = props.value, other = _object_without_properties(props, [
        "children",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "onChange",
        "onClick",
        "selected",
        "size",
        "value"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    var classes = useUtilityClasses(ownerState);
    var handleChange = function(event) {
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) {
                return;
            }
        }
        if (onChange) {
            onChange(event, value);
        }
    };
    var positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ _jsx(ToggleButtonRoot, _object_spread_props(_object_spread({
        className: clsx(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other), {
        children: children
    }));
});
process.env.NODE_ENV !== "production" ? ToggleButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'standard',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        PropTypes.string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: PropTypes.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: PropTypes.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: PropTypes.bool,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: PropTypes.bool,
    /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onChange: PropTypes.func,
    /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */ onClick: PropTypes.func,
    /**
   * If `true`, the button is rendered in an active state.
   */ selected: PropTypes.bool,
    /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */ size: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'small',
            'medium',
            'large'
        ]),
        PropTypes.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */ value: PropTypes /* @typescript-to-proptypes-ignore */ .any.isRequired
} : void 0;
export default ToggleButton;
